"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = void 0;
var api_service_1 = require("./api-service");
var auth_helpers_1 = require("../helpers/auth/auth-helpers");
var AuthService = /** @class */ (function (_super) {
    __extends(AuthService, _super);
    function AuthService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'auth';
        return _this;
    }
    AuthService.prototype.isTokenValid = function (token) {
        var jwt = (0, auth_helpers_1.jwt)(token);
        return Boolean((jwt === null || jwt === void 0 ? void 0 : jwt.exp) && jwt.exp > (0, auth_helpers_1.getTime)() + 60);
    };
    AuthService.prototype.refreshAccessToken = function (refreshToken) {
        return this.login({
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            client_id: this.api.config.clientId,
        });
    };
    AuthService.prototype.login = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!data.client_id && _this.api.config.clientId) {
                data.client_id = _this.api.config.clientId;
            }
            return _this.postRequest(_this.url('oauth/token'), data, { headers: { Authorization: null } })
                .then(function (res) {
                _this.setTokens(res.access_token, res.refresh_token);
                resolve(res);
            })
                .catch(function (err) { return reject(err); });
        });
    };
    AuthService.prototype.logout = function () {
        this.setTokens(undefined, undefined);
    };
    AuthService.prototype.users = function (params) {
        return this.getCollectionRequest(this.url('users'), {
            params: params,
        });
    };
    AuthService.prototype.createUser = function (data) {
        return this.postRequest(this.url('users'), data);
    };
    AuthService.prototype.getUser = function (id) {
        return this.getRequest(this.url('users', id));
    };
    AuthService.prototype.getUserByCustomerId = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.users({ filter: { customer_id: customerId } }).then(function (data) { return data.data[0] || undefined; })];
            });
        });
    };
    AuthService.prototype.updateUser = function (id, data) {
        return this.patchRequest(this.url('users', id), data);
    };
    AuthService.prototype.deleteUser = function (id) {
        return this.deleteRequest(this.url('users', id));
    };
    AuthService.prototype.generateUserPassword = function (id) {
        return this.putRequest(this.url('users', id, 'password', 'generate'));
    };
    AuthService.prototype.resetUserPassword = function (email, redirectUrl) {
        return this.postRequest(this.url('users', 'password', 'reset'), {
            email: email,
            redirect_url: redirectUrl,
        });
    };
    AuthService.prototype.changePassword = function (token, data) {
        return this.patchRequest(this.url('users', 'password', 'reset', token), data);
    };
    AuthService.prototype.clients = function (params) {
        return this.getCollectionRequest(this.url('clients'), {
            params: params,
            headers: { 'x-store-id': null },
        });
    };
    AuthService.prototype.getClient = function (id) {
        return this.getRequest(this.url('clients', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.createClient = function (data) {
        return this.postRequest(this.url('clients'), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.updateClient = function (id, data) {
        return this.putRequest(this.url('clients', id), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.deleteClient = function (id) {
        return this.deleteRequest(this.url('clients', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.permissions = function (params) {
        return this.getCollectionRequest(this.url('permissions'), {
            params: params,
            headers: { 'x-store-id': null },
        });
    };
    AuthService.prototype.createPermission = function (data) {
        return this.postRequest(this.url('permissions'), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.getPermission = function (id) {
        return this.getRequest(this.url('permissions', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.updatePermission = function (id, data) {
        return this.putRequest(this.url('permissions', id), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.deletePermission = function (id) {
        return this.deleteRequest(this.url('permissions', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.roles = function (params) {
        return this.getCollectionRequest(this.url('roles'), {
            params: params,
            headers: { 'x-store-id': null },
        });
    };
    AuthService.prototype.getRole = function (id) {
        return this.getRequest(this.url('roles', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.updateRole = function (id, data) {
        return this.putRequest(this.url('roles', id), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.createRole = function (data) {
        return this.postRequest(this.url('roles'), data, { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.deleteRole = function (id) {
        return this.deleteRequest(this.url('roles', id), { headers: { 'x-store-id': null } });
    };
    AuthService.prototype.setTokens = function (accessToken, refreshToken) {
        this.api.config.accessToken = accessToken;
        this.api.config.refreshToken = refreshToken;
    };
    AuthService.prototype.terms = function (params) {
        return this.getCollectionRequest(this.url('terms'), { params: params, headers: { 'x-store-id': null } });
    };
    return AuthService;
}(api_service_1.ApiService));
exports.default = AuthService;
var UserType;
(function (UserType) {
    UserType["ADMIN"] = "admin";
    UserType["CUSTOMER"] = "customer";
    UserType["GUEST"] = "guest";
    UserType["SUPER_ADMIN"] = "super_admin";
})(UserType = exports.UserType || (exports.UserType = {}));
//# sourceMappingURL=auth-service.js.map